__turbopack_context__.v({
  "active": "SwitcherButton-module-scss-module__KfxdzG__active",
  "switcherButton": "SwitcherButton-module-scss-module__KfxdzG__switcherButton",
  "tooltip": "SwitcherButton-module-scss-module__KfxdzG__tooltip",
});
